import { render, staticRenderFns } from "./RecapCommandes.vue?vue&type=template&id=795799e9&"
import script from "./RecapCommandes.vue?vue&type=script&lang=js&"
export * from "./RecapCommandes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports